import React, { useState } from "react";
import styled from "styled-components";
import EndObserver from "./EndObserver";


export const LazyImage =({className,style ,src, alt, onClick})=>{
    const [show, setShow] = useState(false);
    // return <img className={className} src={src} alt={alt} onClick={onClick} />
    if(show){
        return <img className={className} src={src} alt={alt} onClick={onClick} style={{opacity: 0, ...style}} onLoad={(e) => e.target.style.opacity = 1}/>
    } else {
        return <EndObserver func={() => setShow(true)}/>
    }
    
}